import React, { useState } from 'react';
import { IconButton } from 'rsuite';
import { Icon } from '@rsuite/icons';
import { FaTrashAlt } from 'react-icons/fa';
import { removeProductFromPricing } from '../../api/products';
import handleError from '../../api/apiErrorHandle';
import { notificationSuccess } from '../../services/notificationActions';
import Alert from '../Alert';

interface Props {
  productId: number;
  productCode: string;
  isInPricing: boolean;
  onRemoved: () => void;
}

export default function ProductTablePricingCell({
  productId, productCode, isInPricing, onRemoved,
}: Props) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [removing, setRemoving] = useState(false);

  async function handleRemove() {
    setRemoving(true);
    try {
      await removeProductFromPricing(productId);
      notificationSuccess('Product was removed from pricing.');
      onRemoved();
    } catch (error) {
      handleError(error);
    } finally {
      setRemoving(false);
      setConfirmOpen(false);
    }
  }

  if (!isInPricing) {
    return null;
  }

  return (
    <>
      <IconButton
        appearance="subtle"
        size="sm"
        circle
        title="Click to remove the product from pricing"
        icon={<Icon as={FaTrashAlt} color="red" />}
        onClick={() => setConfirmOpen(true)}
      />

      <Alert
        isOpen={confirmOpen}
        isLoading={removing}
        onConfirm={() => handleRemove()}
        onClose={() => setConfirmOpen(false)}
        title="Confirmation"
      >
        <p>
          Are you sure you want to remove product
          {' '}
          <b>{productCode}</b>
          {' '}
          from pricing?
        </p>
      </Alert>
    </>
  );
}
